import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import * as enCommon from "@utils/stringLocalization/common.json";

export const defaultNS = "common";

i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  debug: true,
  ns: [defaultNS],
  defaultNS,
  resources: {
    en: {
      common: enCommon,
    },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
